'use strict';

var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var styled = require('styled-components');
var noop = require('@userzoomlibraries/toolkit-js-utils/noop');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var noop__default = /*#__PURE__*/_interopDefaultCompat(noop);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var ThemeConsumer = function ThemeConsumer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsxRuntime.jsx(styled.ThemeConsumer, {
    children: children
  });
};

ThemeConsumer.COMPONENT_ID = 'Gearz.ThemeConsumer';
ThemeConsumer.displayName = ThemeConsumer.COMPONENT_ID;
ThemeConsumer.propTypes = {
  children: PropTypes__default["default"].funcWithDescription('Content of the theme consumer.')
};
ThemeConsumer.defaultProps = {
  children: noop__default["default"]
};

exports.ThemeConsumer = ThemeConsumer;
